import { render, staticRenderFns } from "./Categorize.vue?vue&type=template&id=2d6c708c&"
import script from "./Categorize.vue?vue&type=script&lang=js&"
export * from "./Categorize.vue?vue&type=script&lang=js&"
import style0 from "./Categorize.vue?vue&type=style&index=0&id=2d6c708c&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports